export const getAllSubSubCategories = mediaSubCategories => {
  return mediaSubCategories.reduce((acc, subCategory) => {
    return [...acc, ...subCategory.sub_sub_categories]
  }, [])
}
